import RiderWithBenefitModal from './rider-benefit-modal'
import RiderBenefitSummary from './rider-benefit-summary'
import { AgentProtectionDisclaimer } from './agent-protection-disclaimer'

const WPRiderBenefit = ({ rider }) => {
  const description = `ผลประโยชน์${rider.description}`
  const title = `${description} (${rider.name})`
  const benefitTable = (
    <div className="details-table">
      <p>
        กรณีทุพพลภาพสิ้นเชิงก่อนอายุ {rider.coveragePeriod.value} ปี บริบูรณ์
        จะได้รับการยกเว้นเบี้ยประกันภัยของสัญญาหลัก โดยผลประโยชน์จากสัญญาหลักยังเหมือนเดิม
      </p>
    </div>
  )

  const benefitRider = { ...rider, description }
  return (
    <RiderWithBenefitModal id="wp-rider-benefit" className="rider wp-rider" title={title} modalChildren={benefitTable}>
      <RiderBenefitSummary rider={benefitRider} />
      {benefitTable}
      <AgentProtectionDisclaimer rider={rider} />
    </RiderWithBenefitModal>
  )
}

export default WPRiderBenefit
